import styled from 'styled-components';
import { Icon, Text } from '@amzn/storm-ui';

export const RegistrationFormBusinessDetailsInfoText = styled(Text)`
  && {
    margin-block-end: ${({ theme }) => theme.spacing.small.default};
  }
`;

export const RegistrationBusinessDetailsInfoWrapper = styled.div`
  display: flex;
  margin-block-start: ${({ theme }) => theme.spacing.small.default};
`;

export const BusinessDetailsInfoIcon = styled(Icon)`
  && {
    margin-inline-end: ${({ theme }) => theme.spacing.xxsmall.default};
    color: ${({ theme }) => theme.color.lightBlue[700]};
  }
`;
